var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},[_c('div',{class:_vm.progressClass,style:({width: _vm.progressWidth, background: _vm.color})})])
}
var staticRenderFns = []

export { render, staticRenderFns }